module.exports = __webpack_public_path__ + "img/shiba-head-level5.cecd72fe.png";